import { computed } from "vue";

import { DateRange } from "@/domains/v4b/site-consumption/site-consumption.types";
import $date, { EDateScaling } from "@/utils/date";

export function useDashboardDateRange() {
  const TODAY = new Date();
  const TO_DAY = $date.subtract(TODAY, 2, EDateScaling.DAY);
  const FROM_DAY = $date.subtract(TODAY, 32, EDateScaling.DAY);

  const dateRange = computed<DateRange>(() => {
    return {
      from: $date.formatLocalDate(FROM_DAY),
      to: $date.formatLocalDate(TO_DAY),
    };
  });

  return {
    TODAY,
    TO_DAY,
    FROM_DAY,
    dateRange,
  };
}
